import { render, staticRenderFns } from "./TheCompanyCMS.vue?vue&type=template&id=1bb41e4a&scoped=true"
import script from "./TheCompanyCMS.vue?vue&type=script&lang=js"
export * from "./TheCompanyCMS.vue?vue&type=script&lang=js"
import style0 from "./TheCompanyCMS.vue?vue&type=style&index=0&id=1bb41e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb41e4a",
  null
  
)

export default component.exports